import React from "react";
import Webcam from "react-webcam";

interface WebcamCaptureProps {
  captured: Function;
  closeWebcam: Function;
}

class WebcamCapture extends React.Component<WebcamCaptureProps> {
  setRef = (webcam: any) => {
    this.webcam = webcam;
  };
  webcam: any;

  componentWillMount() {
    document.getElementsByTagName("body")[0].classList.add("modal-open");
  }

  componentWillUnmount() {
    document.getElementsByTagName("body")[0].classList.remove("modal-open");
  }

  capture = () => {
    this.props.captured(this.webcam.getScreenshot());
  };

  render() {
    return (
      <span>
        <div className="modal fade in" id="modal-mygallery">
          <div className="modal-dialog" role="document">
            <div className="close-modal">
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={() => this.props.closeWebcam()}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-content">
              <div className="modal-body">
                <Webcam
                  audio={false}
                  height={450}
                  ref={this.setRef}
                  screenshotFormat="image/jpeg"
                  width={500}
                />
              </div>
              <div className="modal-footer">
                <div className="modal-footer-details">
                  <a
                    href="#"
                    className="btn btn-primary"
                    onClick={this.capture}
                  >
                    Capture photo
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade in"></div>
      </span>
    );
  }
}

export default WebcamCapture;
